// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { ItemDetail } from '@/items/api/types';
import { formatNumber } from '@/utilities/number';
import { Box, Paper, Stack, Typography, alpha } from '@mui/material';

interface Props {
  item: ItemDetail;
}

function getItemTypeLabel(type: string): string {
  switch (type) {
    case 'SERVICE':
      return 'Service item';
    case 'DEVICE':
      return 'Device item';
    case 'BULK':
      return 'Bulk item';
    default:
      return 'Item';
  }
}

export function ItemComparisonCard(props: Props) {
  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2,
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.2),
      }}
    >
      <Typography variant="h6">
        {props.item.sku}{' '}
        <Typography variant="inherit" color="text.secondary" component="span">
          ({props.item.name})
        </Typography>
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {getItemTypeLabel(props.item.type)}
      </Typography>
      <Box>
        <Typography variant="subtitle2" sx={{ mt: 2, mb: 1 }}>
          Current associations
        </Typography>
        {props.item.type === 'SERVICE' ? (
          <Typography variant="body2" color="text.secondary">
            None
          </Typography>
        ) : (
          <Stack gap={1} direction="column" sx={{ flexGrow: 1 }}>
            <Paper
              variant="outlined"
              sx={{
                p: 2,
                textAlign: 'left',
                display: 'flex',
                alignItems: 'baseline',
                gap: 1,
              }}
            >
              <Typography variant="body1" fontWeight="bold">
                {formatNumber(props.item.assetCount ?? 0)}
              </Typography>
              <Typography variant="body2">assets</Typography>
            </Paper>
            <Paper
              variant="outlined"
              sx={{
                p: 2,
                textAlign: 'left',
                display: 'flex',
                alignItems: 'baseline',
                gap: 1,
              }}
            >
              <Typography variant="body1" fontWeight="bold">
                {formatNumber(props.item.bom?.length ?? 0)}
              </Typography>
              <Typography variant="body2">bom parts</Typography>
            </Paper>
            <Paper
              variant="outlined"
              sx={{
                p: 2,
                textAlign: 'left',
                display: 'flex',
                alignItems: 'baseline',
                gap: 1,
              }}
            >
              <Typography variant="body1" fontWeight="bold">
                {formatNumber(props.item.fields.length)}
              </Typography>
              <Typography variant="body2">item fields</Typography>
            </Paper>
          </Stack>
        )}
      </Box>
    </Paper>
  );
}
